/* Native Shopify multi-item cart addition; discount eligibility belongs to Shopify. */
if (!customElements.get('potion-bundle-builder')) {
  customElements.define('potion-bundle-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.form = this.querySelector('form');
      this.button = this.querySelector('button[type="submit"]');
      this.message = this.querySelector('.potion-builder__message');
      this.inputs = [...this.querySelectorAll('input[data-eligible]')];
      this.minimum = Number(this.dataset.minimum) || 3;
      this.discountPercent = Number(this.dataset.discountPercent) || 10;
      this.maximum = Math.max(this.minimum, Number(this.dataset.maximum) || 4);
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' });
      this.form.addEventListener('change', event => {
        if (event.target.matches('[data-bundle-variant]')) this.changeVariant(event.target);
        this.update();
      }, { signal: this.controller.signal });
      this.form.addEventListener('submit', event => this.addBundle(event), { signal: this.controller.signal });
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    changeVariant(select) {
      const option = select.selectedOptions[0];
      const card = select.closest('.potion-builder__item');
      const input = card.querySelector('input[name="bundle_product"]');
      const available = !!option && !option.disabled && option.dataset.available === 'true';
      input.dataset.variantAvailable = String(available);
      if (!available) { input.checked = false; return; }
      input.value = option.value;
      input.dataset.price = option.dataset.price;
      input.setAttribute('aria-label', `Select ${card.dataset.productTitle} — ${option.dataset.variantTitle}`);
      card.querySelector('.potion-builder__price').textContent = option.dataset.priceLabel;
      const image = card.querySelector('.potion-builder__choice img');
      if (image && option.dataset.image) {
        image.src = option.dataset.image;
        image.removeAttribute('srcset');
        image.alt = `${card.dataset.productTitle} — ${option.dataset.variantTitle}`;
      }
    }
    update() {
      this.selected = this.inputs.filter(input => input.checked && input.dataset.variantAvailable !== 'false');
      this.inputs.forEach(input => { input.disabled = this.busy || input.dataset.variantAvailable === 'false' || (!input.checked && this.selected.length >= this.maximum); });
      this.querySelectorAll('[data-bundle-variant]').forEach(select => { select.disabled = !!this.busy; });
      const subtotal = this.selected.reduce((total, input) => total + Number(input.dataset.price), 0);
      const remaining = Math.max(0, this.minimum - this.selected.length);
      const savings = remaining === 0 ? this.selected.reduce((total, input) => total + Math.floor(Number(input.dataset.price) * this.discountPercent / 100), 0) : 0;
      const subtotalOutput = this.querySelector('[data-subtotal]');
      subtotalOutput.textContent = this.money.format(subtotal / 100);
      subtotalOutput.classList.toggle('potion-builder__original-price', savings > 0);
      this.querySelector('[data-savings-row]').hidden = savings === 0;
      this.querySelector('[data-discounted-row]').hidden = savings === 0;
      this.querySelector('[data-savings]').textContent = `−${this.money.format(savings / 100)}`;
      this.querySelector('[data-discounted-total]').textContent = this.money.format((subtotal - savings) / 100);
      this.querySelector('.potion-builder__progress').textContent = remaining > 0
        ? `${this.selected.length} selected · Choose ${remaining} more ${remaining === 1 ? 'item' : 'items'} to save ${this.discountPercent}%.`
        : `${this.selected.length} selected · You save ${this.discountPercent}%.`;
      this.button.disabled = !!this.busy || this.selected.length < this.minimum || this.selected.length > this.maximum;
    }
    async addBundle(event) {
      event.preventDefault();
      if (this.button.disabled || this.busy) return;
      if (this.dataset.preview === 'true') {
        try {
          if (!window.potionPreviewCart) throw new Error('The preview bag is not ready. Refresh and try again.');
          window.potionPreviewCart.add(this.selected.map(input => ({ id: input.value, quantity: 1 })));
          this.message.textContent = 'Your bundle has been added to the preview bag.';
          this.inputs.forEach(input => { input.checked = false; });
          this.update();
          window.location.assign(this.dataset.cartUrl || '/cart/');
        } catch (error) { this.message.textContent = error.message; }
        return;
      }
      this.busy = true;
      this.button.textContent = 'Adding your bundle…';
      this.message.textContent = '';
      const items = this.selected.map(input => ({ id: input.value, quantity: 1 }));
      this.update();
      try {
        const drawer = document.querySelector('cart-drawer');
        const payload = { items };
        if (drawer) {
          payload.sections = drawer.getSectionsToRender().map(section => section.id);
          payload.sections_url = window.location.pathname;
          drawer.setActiveElement(this.button);
        }
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(payload)
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Your bundle could not be added. Please review availability and try again.');
        // Once added, never invite an automatic retry if drawer rendering fails.
        this.message.textContent = 'Your bundle has been added to your bag.';
        this.inputs.forEach(input => { input.checked = false; });
        if (drawer && result.sections) {
          try { drawer.classList.remove('is-empty'); drawer.renderContents(result); }
          catch (_) { window.location.assign(this.dataset.cartUrl); }
        } else { window.location.assign(this.dataset.cartUrl); }
      } catch (error) {
        this.message.textContent = error.message || 'Could not connect. Check your bag before trying again.';
      } finally {
        this.busy = false;
        this.button.textContent = 'Add your bundle to bag';
        this.update();
      }
    }
  });
}
